export default __webpack_public_path__ + "static/media/process-preview.636243c8.png";